// removed by extract-text-webpack-plugin
module.exports = {"root":"styles-app__root__1MVU_"};


//////////////////
// WEBPACK FOOTER
// ./styles/app.scss
// module id = 332
// module chunks = 0